import React from 'react';
import { validationClasses } from '@/utils/errors';
import UrlEditor from '@/components/text-editors/UrlEditor';
import { splitUrl } from '@/constants/urls';
import { camelConverter } from '../helper';

const FormUrl = ({
  autoFocus,
  disabled,
  error,
  field,
  onChange,
  text,
  upward,
}) => {
  const updateUriLink = (value) => onChange(splitUrl(value, text.protocol));

  const updateUriProtocol = (value) => onChange({ protocol: value });

  // TODO revert ?. once tasks form is exploded
  return (
    <UrlEditor
      autoFocus={autoFocus}
      className={validationClasses(error, 'aridhia-form-url-input aridhia-is-edit-mode')}
      disabled={disabled}
      id={camelConverter(field.name, '_')}
      fluid
      maxLength={field.validation?.maximum}
      onChange={(e) => updateUriLink(e.target.value)}
      onProtocolChange={(e, { value }) => { updateUriProtocol(value); }}
      placeholder={field.placeholder}
      protocol={text?.protocol}
      upward={upward}
      value={text?.link || ''}
    />
  );
};

export default FormUrl;
